import { nowSecondAtom, selectAtomPerMinute } from "../main";

/**
 * This represents the current minute which is updated only every minute.
 */
export const nowAtom = selectAtomPerMinute(nowSecondAtom);
